import { useEffect } from 'react'
import { useAuth } from './Layout'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()

  useEffect(() => {
    const root = document.documentElement
    const theme_mode = user?.school?.theme_mode || 'light'

    // Aplica modo dark/light
    if (theme_mode === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }

    // As cores primary/secondary do admin são fixas (BeeWave brand)
    // definidas no CSS. Não sobrescrever com cores da escola.
  }, [user?.school?.theme_mode])

  return <>{children}</>
}
